// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"8d580860","344":"84ec8215","375":"5332c2fe"}[chunkId] + ".chunk.js";
};